import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";
export const downloads = (path, type) => {
    return dispatch => {
        dispatch({type:actionType.LOADER_TRUE});
        axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/${path}`, {headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token')
        }}).then((res) => {            
            dispatch({type:actionType.LOADER_FALSE})
            if (res.data && res.data.body && res.data.body.action) {
                if (type === "exception") {
                    dispatch({
                        type: actionType.DOWNLOADS_EXCEPTION,
                        data: res.data.body
                    })
                } else {
                    dispatch({
                        type: actionType.DOWNLOADS_JSON,
                        data: res.data.body
                    })
                }

                toaster("success", res.data.message)
            } else {
                toaster("error", res.data.message)
                dispatch({type:actionType.DOWNLOADS_CLEAR})
            }
        }).catch(()=>{
            dispatch({type:actionType.LOADER_FALSE})
        })
    }
}